import { useHistory } from "react-router-dom";
import { useEmailMarketingTemplatePaths } from "@/react/components/shared/Emails/Templates/TemplatePathContext";
import { Form } from "@/react/components/shared/uikit/Form";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { ModalBody } from "./ModalBody";
import { ModalFooter } from "./ModalFooter";
import { ModalHeader } from "./ModalHeader";

export type Editor = "visual" | "text" | null;

export const EditorSelectionModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const history = useHistory();
  const { visualBuilderPath, contentPath } = useEmailMarketingTemplatePaths();

  const handleSubmit = (data: { editor: Editor }) => {
    const path = data.editor === "visual" ? visualBuilderPath : contentPath;

    onClose();
    history.push(path);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content size="lg" wrapperClassName="!h-full">
        <Form
          onSubmit={handleSubmit}
          defaultValues={{ editor: null }}
          shouldStopPropagation
        >
          <ModalHeader onClose={onClose} />
          <ModalBody />
          <ModalFooter onClose={onClose} />
        </Form>
      </Modal.Content>
    </Modal>
  );
};
